import React from 'react';

interface IconProps extends React.SVGProps<SVGSVGElement> {
  width?: number | string;
  height?: number | string;
  isActive?: boolean;
}

const UserIcon: React.FC<IconProps> = ({
  width = 16,
  height = 16,
  isActive = false,
  ...props
}) => (
  <svg
    width="16"
    height="18"
    viewBox="0 0 16 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 9.83341C9.99667 9.83341 11.8125 10.4117 13.1483 11.2267C13.815 11.6334 14.385 12.1134 14.7967 12.6351C15.2017 13.1476 15.5 13.7609 15.5 14.4167C15.5 15.1209 15.1575 15.6759 14.6642 16.0717C14.1975 16.4467 13.5817 16.6951 12.9275 16.8684C11.6125 17.2159 9.8575 17.3334 8 17.3334C6.1425 17.3334 4.3875 17.2167 3.0725 16.8684C2.41833 16.6951 1.8025 16.4467 1.33583 16.0717C0.841666 15.6751 0.5 15.1209 0.5 14.4167C0.5 13.7609 0.798333 13.1476 1.20333 12.6342C1.615 12.1134 2.18417 11.6342 2.85167 11.2259C4.1875 10.4126 6.00417 9.83341 8 9.83341ZM8 11.5001C6.31417 11.5001 4.7975 11.9917 3.72 12.6492C3.18083 12.9776 2.77417 13.3342 2.51167 13.6676C2.24167 14.0092 2.16667 14.2676 2.16667 14.4167C2.16667 14.5184 2.1975 14.6259 2.37917 14.7717C2.58667 14.9384 2.9475 15.1109 3.49917 15.2567C4.5975 15.5484 6.17583 15.6667 8 15.6667C9.825 15.6667 11.4025 15.5476 12.5 15.2567C13.0525 15.1109 13.4133 14.9384 13.6208 14.7717C13.8025 14.6259 13.8333 14.5184 13.8333 14.4167C13.8333 14.2667 13.7583 14.0092 13.4892 13.6676C13.2258 13.3342 12.8192 12.9776 12.28 12.6492C11.2025 11.9909 9.68583 11.5001 8 11.5001ZM8 0.666748C9.10507 0.666748 10.1649 1.10573 10.9463 1.88714C11.7277 2.66854 12.1667 3.72835 12.1667 4.83341C12.1667 5.93848 11.7277 6.99829 10.9463 7.77969C10.1649 8.56109 9.10507 9.00008 8 9.00008C6.89493 9.00008 5.83512 8.56109 5.05372 7.77969C4.27232 6.99829 3.83333 5.93848 3.83333 4.83341C3.83333 3.72835 4.27232 2.66854 5.05372 1.88714C5.83512 1.10573 6.89493 0.666748 8 0.666748ZM8 2.33341C7.6717 2.33341 7.34661 2.39808 7.04329 2.52372C6.73998 2.64935 6.46438 2.8335 6.23223 3.06565C6.00009 3.29779 5.81594 3.57339 5.6903 3.87671C5.56466 4.18002 5.5 4.50511 5.5 4.83341C5.5 5.16172 5.56466 5.48681 5.6903 5.79012C5.81594 6.09344 6.00009 6.36904 6.23223 6.60118C6.46438 6.83333 6.73998 7.01748 7.04329 7.14311C7.34661 7.26875 7.6717 7.33341 8 7.33341C8.66304 7.33341 9.29893 7.07002 9.76777 6.60118C10.2366 6.13234 10.5 5.49646 10.5 4.83341C10.5 4.17037 10.2366 3.53449 9.76777 3.06565C9.29893 2.59681 8.66304 2.33341 8 2.33341Z"
      fill="#828088"
    />
  </svg>
);

export default UserIcon;
